<div class="organisation-committees">
  <div class="organisation-committees__content content">
    <div class="content__header">
      <h1 class="content__title">{{ 'menu.committees' | customNames }}</h1>
    </div>

    <div class="content__list">
      <app-new-list
        [items]="committees$ | async"
        [itemContentTmp]="committeeTmp"
        (selectedIdChange)="onSelectedCommitteeIdChange($event)"
      ></app-new-list>
    </div>
  </div>
</div>

<ng-template #committeeTmp let-item>
  <new-list-item-committee [item]="item"></new-list-item-committee>
</ng-template>
